<template>
  <v-container fluid class="salesorder-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Sales Order</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Sales Order</p>
                        <v-select
                          class="mb-4"
                          :items=salesordertype
                          v-model="add_salesorder.salesordertype"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the sales order type">
                        </v-select>
                        <v-menu
                          ref="menu_salesorderdate"
                          v-model="menu_salesorderdate"
                          :close-on-content-click="false"
                          :return-value.sync="add_salesorder.salesorderdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="add_salesorder.salesorderdate"
                              label="Sales Order Date"
                              v-bind="attrs"
                              v-bind:value="add_salesorder.salesorderdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please choose the sales order date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="add_salesorder.salesorderdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_salesorderdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_salesorderdate.save(add_salesorder.salesorderdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          append-icon="mdi-magnify"
                          @click:append="searchCustomerDialog"
                          placeholder="Customer Name"
                          single-line hint="Select the Customer"
                          outlined
                          dense
                          readonly
                          persistent-hint
                          v-model="customername"
                          v-bind:error="errorindex == 5"
                        >
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="add_salesorder.salesordername"
                          outlined
                          dense
                          placeholder="Customer Name"
                          persistent-hint
                          single-line hint="Enter the customer name">
                        </v-text-field>      
                        <v-textarea
                          v-model="add_salesorder.salesorderaddress"
                          v-bind:error="errorindex == 6"
                          outlined
                          rows=2
                          label="Address"
                          hint="please enter the customer address"
                        ></v-textarea>
                        <v-text-field
                          class="mb-4"
                          v-model="add_salesorder.salesorderphone"
                          v-bind:error="errorindex == 7"
                          outlined
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line hint="Enter the phone">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="add_salesorder.salesordermobile"
                          outlined
                          dense
                          placeholder="Mobile"
                          persistent-hint
                          single-line hint="Enter the mobile phone">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="add_salesorder.salesorderemail"
                          outlined
                          dense
                          placeholder="Email"
                          persistent-hint
                          single-line hint="Enter the email">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="locations.map(x => {
                            return {text: x.locationname, value: x._id};
                            })"
                          v-model="add_salesorder.locationid"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="saleschannels.map(x => {
                            return {text: x.channelname, value: x._id};
                            })"
                          v-model="add_salesorder.channelid"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Channel"
                          persistent-hint
                          single-line hint="Please choose the channel">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="users.filter(user=>user.userstatus=='Active').map(x => {
                            return {text: x.username, value: x._id};
                            })"
                          v-model="add_salesorder.userid"
                          v-bind:error="errorindex == 8"
                          outlined
                          dense
                          placeholder="Sales Rep"
                          persistent-hint
                          single-line hint="Please choose the sales rep">
                        </v-select>

                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                          v-model="add_salesorder.primaryCurrency"
                          v-bind:error="errorindex == 21"
                          outlined
                          dense
                          placeholder="Primary Currency"
                          persistent-hint
                          single-line hint="Please choose the primary currency">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                          v-model="add_salesorder.secondaryCurrency"
                          v-bind:error="errorindex == 22"
                          outlined
                          dense
                          placeholder="Secondary Currency"
                          persistent-hint
                          single-line hint="Please choose the secondary currency">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="add_salesorder.currencyRate"
                          v-bind:error="errorindex == 23"
                          outlined
                          dense
                          placeholder="Rate"
                          persistent-hint
                          single-line hint="Enter the currency rate">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=salesorderpayterms
                          v-model="add_salesorder.salesorderpayterms"
                          v-bind:error="errorindex == 11"
                          outlined
                          dense
                          placeholder="Pay Terms"
                          persistent-hint
                          single-line hint="Please choose the pay terms">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="paymethods.map(x => {
                            return {text: x.paymethodname, value: x._id};
                            })"
                          v-model="add_salesorder.paymethodid"
                          v-bind:error="errorindex == 12"
                          outlined
                          dense
                          placeholder="Payment Method"
                          persistent-hint
                          single-line hint="Please choose the payment method">
                        </v-select>
                        <v-textarea
                          v-model="add_salesorder.salesordernote"
                          outlined
                          rows=3
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3" v-if="add_salesorder.salesordertype=='Daily Sales'">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-textarea
                          v-model="add_salesorder.salesordernote"
                          outlined
                          rows=3
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/salesorder/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkSalesOrder">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row>
                    <v-col md="10">
                      <p class="text-h5">Items</p>
                    </v-col>
                    <v-col md="2" align="right">
                      <v-btn
                        class="button-shadow"
                        color="success"
                        @click="isAddTransaction=true">
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-data-table
                    :headers="headers"
                    :items="transactions"
                    :items-per-page="500"
                    :footer-props="footer"
                    class="elevation-0"
                  >
                    <template v-slot:item.itemimage="{ item }"> 
                      <v-img
                        v-bind:lazy-src="item.itemimage"
                        min-width=50
                        max-width=100
                        v-bind:src="item.itemimage"
                      ></v-img>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn icon color="primary" @click="editTransactionDialog(item)">
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                      <v-btn icon color="primary" @click="deleteTransaction(item)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertSalesOrder()">
                            Save
                          </v-btn>
                        </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isSearchCustomer"
        persistent
        scrollable
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <v-container>
              <v-row>
                <span class="text-h5" style="padding:10px">Search Customer</span>
              </v-row>

            <v-row>
              <v-col cols="12" md="4">
                  <v-form>
                    <v-text-field
                      class="mb-4"
                      append-icon="mdi-magnify"
                      @click:append="searchCustomer"
                      v-model="search_customer.searchtext"
                      outlined
                      dense
                      placeholder="Search"
                      persistent-hint
                      single-line hint="Search customer"
                    >
                    </v-text-field>
                  </v-form>
                </v-col>
            </v-row>
            </v-container>

          </v-card-title>
          <v-card-text style="height: 400px;">
            <v-container>
              <v-row>

                <v-col cols="12" md="12">
                  <v-data-table
                    :items-per-page="100"
                    :headers="customerHeaders"
                    :items="searches"
                    item-value="name"
                  >
                  <template v-slot:item.customerimage="{ item }">
                    <img v-if="item.customerimage" v-bind:src="item.customerimage" alt="" width="80">
                  </template>
                  <template v-slot:item.customername="{ item }">
                    <a class="primaryConst--text">{{ item.customername }}</a>
                    <p>{{ item.customertype }}</p>
                  </template>
                  <template v-slot:item.customeraddress="{ item }">
                    <a class="primaryConst--text">{{ item.customeraddress }}</a>
                    <p class="two-line">{{ item.customerphone  }}</p>
                    <p class="two-line">{{ item.customermobile  }}</p>
                  </template>
                  <template v-slot:item.townshipid="{ item }">
                    <p class="two-line">{{ item.regionid!=undefined && regions.find(region=>region._id == item.regionid)!=null ? regions.find(region=>region._id == item.regionid)['regionname'] : ''   }}</p>
                    <p class="two-line">{{ item.townshipid!=undefined && townships.find(township=>township._id == item.townshipid)!=null ? townships.find(township=>township._id == item.townshipid)['townshipname'] : ''  }}</p>
                  </template>
                  <template v-slot:item.customerstatus="{ item }">
                    <v-chip
                      :color="!item.customerstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                      small>
                      {{ item.customerstatus }}
                    </v-chip>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <div v-if="item._id!=undefined">
                    <v-btn icon color="primary" @click="selectCustomer(item)">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    </div>
                  </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isSearchCustomer = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="searchCustomer"
            >
              Search
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>

              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="items.map(x => {
                      return {text: x.itemname, value: x._id};
                      })"
                    v-model="add_transaction.itemid"
                    v-bind:error="errorindex == 0"
                    dense
                    placeholder="Item"
                    persistent-hint
                    single-line hint="Item">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="add_transaction.itemdesc"
                    class="mb-4"
                    dense
                    placeholder="Description"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="add_transaction.itemquantity"
                    class="mb-4"
                    dense
                    placeholder="Qty"
                    persistent-hint
                    type="number"
                    v-on:input="onChangeQuantity"
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="Quantity">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="add_transaction.itemprice"
                    class="mb-4"
                    dense
                    placeholder="Prc"
                    v-on:input="onChangePrice"
                    persistent-hint
                    single-line hint="Price">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-model="add_transaction.itemamount"
                    class="mb-4"
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>

              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {
                      return {text: x.brandname, value: x._id};
                    })"
                    v-model="edit_transaction.brandid"
                    v-bind:error="errorindex == 2"
                    dense
                    placeholder="Brand"
                    persistent-hint
                    single-line hint="Brand">
                  </v-select>
                </v-col>
                <v-col cols="12" md="8">
                  <v-select
                    class="mb-4"
                    :items="items.filter(item=>item.brandid == edit_transaction.brandid).map(x => {
                      return {text: x.itemname, value: x._id};
                      })"
                    v-model="edit_transaction.itemid"
                    v-bind:error="errorindex == 0"
                    v-on:change="onChangeItemEdit"
                    dense
                    placeholder="Item"
                    persistent-hint
                    single-line hint="Item">
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="edit_transaction.itemquantity"
                    class="mb-4"
                    dense
                    placeholder="Qty"
                    persistent-hint
                    type="number"
                    v-on:input="onChangeQuantityEdit"
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="Quantity">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    type="number"
                    :readonly="edit_transaction.itemfoc=='Foc' || edit_transaction.itemfoc=='Promo'"
                    v-model="edit_transaction.itemprice"
                    class="mb-4"
                    dense
                    placeholder="Prc"
                    v-on:input="onChangePriceEdit"
                    persistent-hint
                    single-line hint="Price">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-model="edit_transaction.itemamount"
                    class="mb-4"
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      headers: [
        { text: 'Image', value: 'itemimage', width: '10%' },
        { text: 'Name', value: 'itemname', width: '10%' },
        { text: 'Description', value: 'itemdesc'},
        { text: 'Qty', value: 'itemquantity', width: '10%'},
        { text: 'Prc', value: 'itemprice', width: '10%'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      customerHeaders: [
        { text: 'Image', value: 'customerimage', sortable: false },
        { text: 'Name', value: 'customername' },
        { text: 'Address', value: 'customeraddress' },
        { text: 'Location', value: 'townshipid' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      
      step: 1,
      menu_salesorderdate: null,
      isSearchCustomer: false,
      isAddTransaction: false,
      isEditTransaction: false,

      customername: null,
      add_salesorder: {},
      add_transaction: {},
      edit_transaction: {},
      search_customer: {},
      transactions: [],
      searches: [],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      salesordertype: ['Sales Order', 'Cash Order'],
      salesorderpayterms: ['Cash', 'Credit 15 Days', 'Credit 30 Days'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('Brand', ['brands']),
    ...mapState('Customer', ['customers']),
    ...mapState('Item', ['items']),
    ...mapState('Location', ['locations']),
    ...mapState('PayMethod', ['paymethods']),
    ...mapState('PriceList', ['pricelists']),
    ...mapState('Region', ['regions']),
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('SalesOrder', ['isReceiving']),
    ...mapState('SystemSetting', ['settings']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users'])
  },
  methods: {
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Customer', ['getCustomersRequest']),
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('PayMethod', ['getPayMethodsRequest']),
    ...mapActions('PriceList', ['getPriceListsRequest']),
    ...mapActions('Region', ['getRegionsRequest']),
    ...mapActions('SalesChannel', ['getSalesChannelsRequest']),
    ...mapActions('SalesOrder', ['getSalesOrders', 'insertSalesOrderRequest']),
    ...mapActions('Search', ['searchCustomerRequest']),
    ...mapActions('SystemSetting', ["getSetting", "getSystemSettingsRequest"]),
    ...mapActions('Township', ['getTownshipsRequest']),
    ...mapActions('User', ['getUsersRequest']),
    checkSalesOrder(){
      if(!this.add_salesorder.salesordertype){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.add_salesorder.salesorderdate){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.add_salesorder.locationid){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.add_salesorder.channelid){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.add_salesorder.customerid){
        this.haserrors = true;
        this.errorindex = 5;
        return false;
      }
      if(!this.add_salesorder.salesorderaddress){
        this.haserrors = true;
        this.errorindex = 6;
        return false;
      }
      if(!this.add_salesorder.salesorderphone){
        this.haserrors = true;
        this.errorindex = 7;
        return false;
      }
      if(!this.add_salesorder.userid){
        this.haserrors = true;
        this.errorindex = 8;
        return false;
      }
      if(!this.add_salesorder.salesorderpayterms){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.add_salesorder.paymethodid){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    addTransaction(){
      this.isAddTransaction = false;
      if(this.add_transaction.itemid==null || this.add_transaction.itemprice==null || this.add_transaction.itemamount==null) return;
      let item = this.items.find(i=>i._id==this.add_transaction.itemid);
      this.add_transaction = Object.assign(this.add_transaction, {itemname: item.itemname, itemimage: item.itemimage});
      this.add_transaction.id = Math.floor(Math.random() * Math.pow(10, 10));
      this.transactions.push(this.add_transaction);
      this.clearTransaction();
    },
    clearTransaction(){
      this.add_transaction = {};
    },
    deleteTransaction(item){
      let index = this.transactions.findIndex((trans) => trans.id == item.id);      
      if(index!=-1) this.transactions.splice(index,1);
    },
    editTransactionDialog(item){
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    editTransaction(){
      this.isEditTransaction = false;
      let index = this.transactions.findIndex((trans) => trans.id == this.edit_transaction.id);
      let trans = Object.assign({}, this.edit_transaction);
      this.transactions.splice(index, 1, trans);
      this.edit_transaction = {};
    },
    findPriceByQuantity(prices, itemid, qty){
      let price = prices.find(price=> price.itemid==itemid && parseInt(qty)>=price.minqty && parseInt(qty)<=price.maxqty);
      return price;
    },
    findItemQuantityById(id){
      let filter_trans = this.transactions.filter(trans=>trans.itemid==id && trans.itemfoc!='Foc' && trans.itemfoc!='Promo');
      var sum = filter_trans.reduce((partial_sum, tran) => parseFloat(partial_sum) + parseFloat(tran.itemquantity),0);
      return sum;
    },
    async insertSalesOrder() {
      if(this.transactions.length==0) return;
      let order = {salesorder: this.add_salesorder, transactions: this.transactions};
      await this.insertSalesOrderRequest(order);
      router.push('/salesorder/list');
    },
    onChangeItem(itemid){
      let item = this.items.find(item=>item._id == itemid);
      let pricelist = this.pricelists.find(list=>list._id==this.add_salesorder.pricelistid);
      if(!this.add_transaction.itemquantity) this.add_transaction.itemquantity = 1;
      let price = this.findPriceByQuantity(pricelist.prices, item._id, this.add_transaction.itemquantity)
      let update = {
        itemid: item._id,
        itemimage: item.itemimage, 
        itemname: item.itemname,
        itemquantity: this.add_transaction.itemquantity,
        itemprice: price!=null ? price.listprice : 0,
      }
      update.itemamount = update.itemprice * update.itemquantity;
      this.add_transaction = Object.assign({}, this.add_transaction, update);
      this.onChangeQuantity();
    },
    onChangeItemEdit(itemid){
      let item = this.items.find(item=>item._id == itemid);
      let pricelist = this.pricelists.find(list=>list._id==this.add_salesorder.pricelistid);
      if(!this.edit_transaction.itemquantity) this.edit_transaction.itemquantity = 1;
      let price = this.findPriceByQuantity(pricelist.prices, item._id, this.edit_transaction.itemquantity);
      let update = {
        itemid: item._id,
        itemimage: item.itemimage, 
        itemname: item.itemname,
        itemquantity: this.edit_transaction.itemquantity,
        itemprice: price!=null ? price.listprice : 0,
      }
      update.itemamount = update.itemprice * update.itemquantity;
      this.edit_transaction = Object.assign({}, this.edit_transaction, update);
      this.onChangeQuantityEdit();
    },
    onChangeQuantity(){
      let update = {};
      update.itemamount =  this.add_transaction.itemquantity * this.add_transaction.itemprice;
      this.add_transaction = Object.assign({}, this.add_transaction, update);
    },
    onChangeQuantityEdit(){
      let update = {};
      update.itemamount =  this.edit_transaction.itemquantity * this.edit_transaction.itemprice;
      this.edit_transaction = Object.assign({}, this.edit_transaction, update);
    },
    onChangePrice(){
      let update = {
        itemamount: this.add_transaction.itemprice * this.add_transaction.itemquantity,
      };
      this.add_transaction = Object.assign({}, this.add_transaction, update);
    },
    onChangePriceEdit(){
      let update = {
        itemamount: this.edit_transaction.itemprice * this.edit_transaction.itemquantity,
      };
      this.edit_transaction = Object.assign({}, this.edit_transaction, update);
    },
    updateTransaction(index){
      let update = {
        itemquantity: parseInt(this.add_transaction.itemquantity),
        itemprice: this.add_transaction.itemprice,
        itemamount: this.add_transaction.itemamount
      };
      this.transactions.splice(index, 1, update);
    },
    searchCustomerDialog(){
      this.search_customer = {};
      this.isSearchCustomer = true;
    },
    selectCustomer(item){
      this.customername = item.customername;
      this.add_salesorder.salesordername = item.customername;
      this.add_salesorder.salesorderaddress = item.customeraddress;
      this.add_salesorder.salesorderphone = item.customerphone;
      this.add_salesorder.salesordermobile = item.customermobile;
      this.add_salesorder.salesorderemail = item.customeremail;
      this.add_salesorder.customertype = item.customertype;
      this.add_salesorder.customerid = item._id;
      this.add_salesorder.regionid = item.regionid;
      this.add_salesorder.townshipid = item.townshipid;
      this.isSearchCustomer = false;
    },
    async searchCustomer(){
      let results = await this.searchCustomerRequest(this.search_customer);
      this.searches = results;
    }
  },

  async created () {
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.customers.length==0) await this.getCustomersRequest();
    if(this.items.length==0) await this.getItemsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.paymethods.length==0) await this.getPayMethodsRequest();
    if(this.pricelists.length==0) await this.getPriceListsRequest();
    if(this.regions.length==0) await this.getRegionsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if(this.settings.length==0) await this.getSystemSettingsRequest();
    if(this.townships.length==0) await this.getTownshipsRequest();
    if(this.users.length==0) await this.getUsersRequest();

    let primaryCurrency = await this.getSetting({code: 'CurrencySettings', name: 'PrimaryCurrency'}, );
    let secondaryCurrency = await this.getSetting({code: 'CurrencySettings', name: 'SecondaryCurrency'}, );
    let currencyRate = await this.getSetting({code: 'CurrencySettings', name: 'DefaultCurrencyRate'}, );
    let isTaxable = await this.getSetting({code: 'TaxSettings', name: 'isTaxEnabled'}, );
    let taxRate = await this.getSetting({code: 'TaxSettings', name: 'TaxRate'}, );
    let isDualCurrency = primaryCurrency!=null && secondaryCurrency!=null ? (primaryCurrency!=secondaryCurrency) : false;
    currencyRate = parseFloat(currencyRate);
    taxRate = parseFloat(taxRate);
    this.add_salesorder = Object.assign({}, {primaryCurrency: primaryCurrency, secondaryCurrency: secondaryCurrency, currencyRate: currencyRate, isTaxable: isTaxable, taxRate: taxRate, isDualCurrency: isDualCurrency});

    //var companyid = localStorage.getItem('companyid');
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
